/* eslint-disable max-len */
/* eslint-disable no-console */
import { Box, Grid, Stack, Typography } from '@mui/material';
import React, { useContext, useId, useMemo } from 'react';
import ProfilePic from '../../../../components/Common/ProfilePic';
import { LanguageContext } from '../../../../libs/Context';
import { DateDiff } from '../../../../libs/HelperContent';
import BookMarkButton from './BookMarkButton';
import LikeButton from '../LeftPart/FeedCards/Card/LikeButton';
import RepostButton from '../LeftPart/FeedCards/Card/RepostButton';
import ShareButton from '../LeftPart/FeedCards/Card/ShareButton';
import CommentButton from '../LeftPart/FeedCards/Card/CommentButton';
import FeedMediaView from '../LeftPart/FeedCards/FeedMediaView';
import SamplePoll from './SamplePoll';
import OccasionCardView from './OccasionCard';
import useNavigateProfile from '../CustomHooks/useNavigateProfile';
import FeedDocView from '../LeftPart/FeedCards/Card/FeedDocView';
import useGetFeedPermissions from '../CustomHooks/useGetFeedPermissions';
import { useSelector } from 'react-redux';
import ReadMoreLess from './ReadMoreLess/Readmoreless';

interface BaseProps {
	item:any,
	showFooterButtons?: boolean,
	showBookmarkButton?: boolean,
	borderstyle?:any,
	borderBtm?:any,
	bordeRadius?:any,
	borTop?:any;
}

const Card = (props: BaseProps) =>
{
	const { item, showFooterButtons = false, showBookmarkButton } = props;
	const feed = showBookmarkButton ? item?.feed?.[0] : item;
	// const media = item?.media ?? feed?.media ?? [];
	const { language } = useContext(LanguageContext);

	const { redirectToProfile, canNavigate } = useNavigateProfile(feed);
	const userData = useSelector((state:any) => state.mysession.session);
	const getPermission = useGetFeedPermissions(item, userData);

	const linkList = useMemo(
		() => feed?.media?.filter((mediaItem) => mediaItem?.type === 'link'),
		[ feed?.media ]
	);

	const mediaList = useMemo(
		() => feed?.media?.filter((mediaItem) => mediaItem?.type !== 'link' && !mediaItem?.type?.match('application')),
		[ feed?.media ]
	);
	const docList = useMemo(
		() => feed?.media?.filter((mediaItem) => mediaItem?.type?.match('application')),
		[ feed?.media ]
	);

	const hasCommentPermission = getPermission('comments');
	const hasLikePermisssion = getPermission('likes');
	const shareAccess = [ 'poll' ].includes(feed?.feedType) || !getPermission('share');
	const repostAccess = feed?.repostObj?.feedId || [ 'occasion', 'poll' ].includes(feed?.feedType) || !getPermission('repost');
	const isFeedPendingOrRejected = [ 'pending', 'rejected' ].includes(feed?.status);
	const showFooter = showFooterButtons && (hasCommentPermission || hasLikePermisssion || !shareAccess || !repostAccess) && !isFeedPendingOrRejected;
	const tempId = useId();

	return (
		<Grid container sx={{ border: props.borderstyle || '1px solid rgba(178, 178, 178, 0.6)', borderRadius: props.bordeRadius || '13px', borderBottom: props.borderBtm }} p='var(--pixel12)'>
			{/* when poll is bookmark */}
			{/* <Grid item xs={12}>

				<SamplePoll
					pollCard={{
						...feed?.pollData,
						id            : feed?._id,
						pollsubmitted : feed?.pollsubmitted,
						createdAt     : feed?.createdAt
					}}
					bordercolor={'var(--primaryColor)4D'}
					Cursor={feed?.pollsubmitted ? 'none' : 'pointer'}
					from='list'
					feed={feed}
				/>
			</Grid> */}

			{/* when occasion is bookmark */}
			{/* <Grid item xs={12} p='var(--pixel8)' >
				<OccasionCardView viewData={feed ?? {}} selectEvent={'occasion'} requestT={'viewEvent'}/>
			</Grid> */}
			<Grid item xs={12}>
				<Grid container flexWrap='nowrap' spacing={1}>
					<Grid item sx={{ flexShrink: 0 }} alignItems='start' display={'flex'}>
						<span
							style={{ width: 'var(--pixel20)', height: 'var(--pixel20)', border: '1px solid rgba(0,0,0,0.12)', borderRadius: 'var(--percent50)' }}
							onClick={redirectToProfile}
							className={canNavigate ? 'pointer' : ''}
						>
							<ProfilePic
								// imagePath={`${feed?.createdBy}_${[ 'employee', 'individual' ].includes(feed?.userData?.role) ? 'profile' : 'logo'}.jpeg?t=${new Date().valueOf()}`}
								defaultImg={([ 'employee', 'individual' ].includes(feed?.userData?.role) ? '/images/icons/defaultUser.svg' : '/images/logos/no_logo.png')}
								alt='createdBy'
								className='brdrRadius50 objectFitCover'
								from={[ 'employee', 'individual' ].includes(feed?.userData?.role) ? 'selfProfile' : ''}
								imagePath={
									[ 'employee', 'individual' ].includes(feed?.userData?.role)
										? `${feed?.createdBy}.jpeg?t=${tempId}`
										: `${feed?.createdBy}_logo.jpeg?t=${tempId}`
								}
							/>
						</span>
					</Grid>
					<Grid item xs sx={{ minWidth: 0, overflow: 'hidden' }} pl='var(--pixel8)'>
						<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
							<Typography
								variant='subtitle1'
								fontWeight='500'
								sx={{
									whiteSpace   : 'nowrap',
									overflow     : 'hidden',
									textOverflow : 'ellipsis',
									width        : 'var(--percent100)',
									lineHeight   : 1.5
								}}
								className={`${canNavigate ? 'pointer ' : ''}capitalTxt`}
								onClick={redirectToProfile}
							>
								{(item?.userData?.role || feed?.userData?.role) === 'company'
									? feed?.userData?.companyName || item?.userData?.companyName
									: feed?.userData?.fullName || item?.userData?.fullName}
							</Typography>
							<Typography fontSize={'var(--pixel12)'} mt={0} color={'rgba(178, 178, 178, 1)'}>
								{DateDiff(feed?.createdAt ?? item?.createdAt, new Date().valueOf())}
								{item?.isEdited ? ` (${language?.edited})` : ''}
							</Typography>

						</Box>
					</Grid>
					{showBookmarkButton && !isFeedPendingOrRejected &&
					<Grid item sx={{ flexShrink: 0 }} alignItems={'start'} display={'flex'} >
						<BookMarkButton isBookmarked={feed?.bookMark} feedId={item?.feedId}/>
					</Grid>
					}
				</Grid>
			</Grid>
			<Grid item xs={12} pt='var(--pixel8)'>
				{/* <div
					className='ellipseLen2'
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html: item?.description ?? feed?.description }}
				/> */}
				<ReadMoreLess
					feedId={feed?._id}
					text={feed?.description || ''}
					maxChars={200}
					fontSize='var(--pixel16)'
					fontWeight={400}
					textColor='#5D5D5D'
					buttonColor='var(--primaryColor)'
					showSpeaker={false}
				/>
				{linkList?.length > 0 &&
							linkList?.map((link, ind) =>
								(
									<Grid item xs={12} key={ind}>
										{/* <a href={link?.url} target='_blank' rel='noreferrer' style={{ color: 'blue', lineBreak: 'anywhere' }}>{link?.url.length > 100 ? `${link.url.slice(0, 100)}...` : link}</a> */}
										<a href={link?.url} target='_blank' rel='noreferrer' style={{ color: 'blue', lineBreak: 'anywhere' }}>
											{link?.url?.length > 100 ? `${link?.url?.slice(0, 100)}...` : link?.url}
										</a>
									</Grid>
								))}
				{docList?.length > 0 && <FeedDocView docList={docList}/>}
				{mediaList?.length > 0 &&
				<FeedMediaView smallIcons mediaData={mediaList} limit={2} feed={feed}/>
				}
			</Grid>

			{showFooter &&
			<Grid item xs={12} mt={1}sx={{
				borderTop : props.borTop || '1px solid #eff2fa'
			}}
			>
				<Stack direction={'row'} spacing={2} alignItems={'center'} pt='var(--pixel12)'>
					{hasLikePermisssion &&
					<LikeButton
						isLiked={item?.selfLike}
						feedId={item?._id}
						feed={feed}
					/>}
					{hasCommentPermission && <CommentButton feed={item}/>}
					{!shareAccess &&
					<ShareButton
						feedId={item?._id}
						feed={feed}
					/>}
					{!repostAccess && <RepostButton feed={item}/>}
				</Stack>
			</Grid>}
		</Grid>

	);
};

export default Card;
